export const systemsConstants = {
    SYSTEMS_LOADING: "systems_loading",
    SYSTEMS_LOADED: "systems_loaded",
    SYSTEMS_ERROR: "systems_error",
}